import React from "react";
import {
	Link
} from "react-router-dom";

import img_brainlabel from './../../images/brainlabel.png';
import img_vbm from './../../images/vbm.jpg';
import img_tbss from './../../images/tbss.jpg';
import img_pet from './../../images/pet.png';

export default class Servicecreate extends React.Component {
	constructor(props) {
		super(props);
		
    let user = {};
		let uistyle = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
      if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
        uistyle = JSON.parse(user.company.type);
      }
    }
		this.state = {
			projectid: props.project.id,
			page_title: '服务介绍 Introduction',
			uistyle:uistyle
		}
	}

	render() {
		const uistyle = this.state.uistyle;
		const projectid = this.state.projectid;

		const links = {
			brainlabel: {
				pathname: '/console/myprojects/project/service_list/' + projectid + '/brainlabel'
			},
			vbm: {
				pathname: '/console/myprojects/project/service_list/' + projectid + '/vbm'
			},
			tbss: {
				pathname: '/console/myprojects/project/service_list/' + projectid + '/tbss'
			},
			create_vbm: {
				pathname: '/console/myprojects/project/service_create/' + projectid + '/vbm'
			},
			create_tbss: {
				pathname: '/console/myprojects/project/service_create/' + projectid + '/tbss'
			},
			pet:{
				pathname: '/console/myprojects/project/service_list/' + projectid + '/pet'
			}
		};

		return (
			<div>
				<div className="card my-3 animated fadeInUp">
				  <div className="card-body">
				    <h5 className="card-title">全脑分割 <small>Brain Label 全脑量化分析</small></h5>
				    <p className="card-text"><img className="img-fluid mb-3 mb-md-0" src={img_brainlabel} alt="brainlabel" /></p>
				    <p className="card-text">
						
				    	全脑分割可实现包括皮层及皮层下结构的全脑自动分割，并提供体积测量、在线阅图、三维重构等多种功能，无需人工设置参数，一键实现智能分析。
				    </p>
				    <Link className="btn btn-dark btn-sm mr-2" to={links.brainlabel}>查看结果</Link>
				  </div>
				</div>
				{uistyle.is_pet &&
					
					<div className="card my-3 animated fadeInUp">
					<div className="card-body">
						<h5 className="card-title">VMAT2-PET <small>纹状体SUVR分析</small></h5>
						<p className="card-text"><img className="img-fluid mb-3 mb-md-0" src={img_pet} alt="pet" /></p>
						<p className="card-text">	9-fluoropropyl-(+)-DTBZ (FP-(+)DTBZ, AV-133)是一种II型囊泡转运蛋白（VMAT2）示踪剂，临床研究表明，帕金森患者脑组织中VMAT2的蛋白含量存在明显减少。本产品用于处理II型囊泡转运蛋白（VMAT2）显像PET脑影像，对被试纹状体（包含壳核、伏核及尾状核）进行分割，对各亚区的AV133示踪剂摄取情况进行计算，用以评估各亚区功能变化。</p>
						<Link className="btn btn-dark btn-sm mr-2" to={links.pet}>查看结果</Link>
					</div>
				</div>

				}
{uistyle.is_vbm &&
				<div className="card my-3 animated fadeInUp">
				  <div className="card-body">
				    <h5 className="card-title">VBM <small>基于体素的形态学测量分析</small></h5>
				    <p className="card-text"><img className="img-fluid mb-3 mb-md-0" src={img_vbm} alt="brainlabel" /></p>
				    <p className="card-text">VBM(Voxel-based Morphometry) 是目前被广泛应用的一种形态计量学方法，主要利用统计推断来描述多个被试之间脑结构的差异，或寻找脑形状的相关信息以说明疾病的严重性。 与传统解剖结构的 ROI 分析方法不同，它可以检验大脑任何位置的差异；另一方面，它可以用于大脑解剖学的任何度量方式，恰当地选择数据和数据变换，大量的解剖特征可以通过简单无偏的方法加以分析。 VBM 方法通常被用来定量计算全脑灰质体积的改变，从而准确地反映脑组织形态学方面的变化。</p>
				    <Link className="btn btn-dark btn-sm mr-2" to={links.vbm}>查看结果</Link>
				    <Link className="btn btn-success btn-sm" to={links.create_vbm}>创建任务</Link>
				  </div>
				</div>
}

{uistyle.is_tbss &&
				<div className="card my-3 animated fadeInUp">
				  <div className="card-body">
				    <h5 className="card-title">TBSS <small>基于纤维束的空间统计分析</small></h5>
				    <p className="card-text"><img className="img-fluid mb-3 mb-md-0" src={img_tbss} alt="brainlabel" /></p>
				    <p className="card-text">TBSS(Tract-based spatial statistics)用于分析弥散张量数据，可对不同被试者的主要白质纤维束对齐、配准，从而达到较精准的组间比较，因此对脑白质异常区域定位更准确，为定量评估脑白质病变提供可靠参数。TBSS能够在配准 FA 图像到目标模板之后，提取 FA 图的骨架——对应于主要脑白质纤维束，再将配准后的 FA 图像投射到对应骨架上，这样一来就不需再进行空间平滑，能有效地减小平滑对结果的影响。</p>
				    <Link className="btn btn-dark btn-sm mr-2" to={links.tbss}>查看结果</Link>
				    <Link className="btn btn-success btn-sm" to={links.create_tbss}>创建任务</Link>
				  </div>
				</div>
}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/project_service_intro.js